import { useEffect } from 'react';
import { useLocation } from 'react-router';

/** Scroll to top on route change */
export function useScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
}
